// BookingWithCounselor.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { createMRTColumnHelper } from "material-react-table";
import Chip from "@mui/material/Chip";
import CustomTable from "../../components/custom_table/CustomTable.jsx";
// import { Icon } from "lucide-react";
import { Box } from "@mui/material";
import { baseUrl } from "../../helper/urls.js";
import { Icon } from "@iconify/react";

import { useSelector } from "react-redux";
const BookingWithCounselor = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  // const counselor = location.state;

  const [counselors, setCounselors] = useState([]);
  console.log("counselor::::::::::::::::::::::::::", counselors);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCounselors = async () => {
    try {
      // console.log("akkkkkkkkkkkkkkkkkkk", counselor);
      const response = await axios.get(
        `${baseUrl}/bookings/counselor/counselorId/status/0`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("akkkkkkkkkkkkkkkkkkk11111");
      console.log("response:::::::::::::::::::::::::::::::", response.data);
      setCounselors(response.data);
      setLoading(false);
    } catch (error) {
      setError("error bookingwihtaaaaaaaaaaaa", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounselors();
  }, []);

  const toggleApproval = async (id, currentStatus) => {
    const newStatus = currentStatus;
    const action = newStatus === 1 ? "Accept" : "Reject";

    const result = await Swal.fire({
      title: `Are you sure ?`,
      text: `You want to ${action.toLowerCase()} this booking.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${action}`,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      await axios.patch(
        `${baseUrl}/bookings/status/${id}`,
        { status: newStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire(
        "Success",
        `Booking ${action.toLowerCase()}ed successfully!`,
        "success"
      );

      if (newStatus === 1) {
        navigate("/approved-bookings");
      } else {
        navigate("/unapproved-bookings");
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    }
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("id", { header: "ID" }),
    columnHelper.accessor("student_id", {
      header: "Student Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.firstName + " " + cell.row.original?.lastName,
    }),
    columnHelper.accessor("booking_date", {
      header: "Booking Date",
      size: 30,
      Cell: (cell) => cell.row.original?.booking_date?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("booking_duration", {
      header: "Duration(mins)",
      size: 30,
      Cell: (cell) => cell.row.original?.booking_duration,
    }),
    columnHelper.accessor("slot_id", {
      header: "Slot Details",
      size: 40,
      Cell: (cell) =>
        cell.row.original?.booking_time + " to " + cell.row.original?.end_time,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      Cell: (cell) =>
        cell.row.original?.status == 1 ? (
          <Chip label="Accepted" color="success" variant="outlined" />
        ) : (
          <Chip label="Pending" color="default" variant="outlined" />
        ),
    }),
    columnHelper.accessor("Actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowId = cell.row.original.id;
        const rowData = cell.row.original;

        return (
          <Box>
            <button
              onClick={() => toggleApproval(rowId, 1)}
              className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
            >
              <Icon icon="material-symbols:check" />
            </button>

            <button
              onClick={() => toggleApproval(rowId, 3)}
              className="w-32-px h-32-px bg-warning-focus text-warning-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
            >
              <Icon icon="ic:round-close" />
            </button>
          </Box>
        );
      },
    }),
  ];

  return <CustomTable columns={columns} data={counselors} loading={loading} />;
};

export default BookingWithCounselor;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import $ from "jquery";
// import "datatables.net-dt/js/dataTables.dataTables.js";
// import { baseUrl } from "../../helper/urls.js";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { createMRTColumnHelper } from "material-react-table";
// import Chip from "@mui/material/Chip";
// import CustomTable from "../../components/custom_table/CustomTable.jsx";

// const BookingWithCounselor = () => {
//   const location = useLocation();
//   const counselor = location.state;

//   console.log("counselor::::::::::::::::::::::::::", counselor);

//   const [counselors, setCounselors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchCounselors = async () => {
//     try {
//       const response = await axios.get(
//         `${baseUrl}/bookings/counselor/${counselor.id}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       console.log("response:::::::::::::::::::::::::::::::", response.data);

//       setCounselors(response.data);
//       setLoading(false);
//     } catch (error) {
//       setError(error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCounselors();
//   }, []);

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("id", {
//       header: "ID",
//       size: 30,
//     }),
//     columnHelper.accessor("student_id", {
//       header: "Student Name",
//       size: 30,
//     }),
//     columnHelper.accessor("counselor_id", {
//       header: "Counselor Name",
//       size: 30,
//     }),
//     columnHelper.accessor("slot_id", {
//       header: "Slot Date",
//       size: 30,
//     }),
//     columnHelper.accessor("status", {
//       header: "Status",
//       size: 30,
//       Cell: (cell) =>
//         cell.row.original?.status == 1 ? (
//           <Chip label="Approved" color="success" variant="outlined" />
//         ) : (
//           <Chip label="Reject" color="warning" variant="outlined" />
//         ),
//     }),
//     columnHelper.accessor("booking_date", {
//       header: "Booking Date",
//       size: 40,
//       Cell: (cell) => cell.row.original?.booking_date?.split("T")[0] || "-",
//     }),
//     columnHelper.accessor("booking_time", {
//       header: "Booking Time",
//       size: 40,
//     }),
//     columnHelper.accessor("booking_duration", {
//       header: "Duration (mins)",
//       size: 40,
//     }),
//     columnHelper.accessor("created_at", {
//       header: "Created At",
//       size: 40,
//       Cell: (cell) => cell.row.original?.created_at?.split("T")[0] || "-",
//     }),
//     columnHelper.accessor("updated_at", {
//       header: "Updated At",
//       size: 40,
//       Cell: (cell) => cell.row.original?.updated_at?.split("T")[0] || "-",
//     }),
//     columnHelper.accessor("is_deleted", {
//       header: "Is Deleted",
//       size: 30,
//       Cell: (cell) =>
//         cell.row.original?.is_deleted == 1 ? (
//           <Chip label="Deleted" color="error" variant="outlined" />
//         ) : (
//           <Chip label="Active" color="primary" variant="outlined" />
//         ),
//     }),
//   ];

//   return (
//     <>
//       <CustomTable columns={columns} data={counselors} loading={loading} />
//     </>
//   );
// };

// export default BookingWithCounselor;
